import type React from "react";
import { useMemo } from "react";
import type { DropdownProps } from "@/components/mosaic/ui/TileTitle/TileTitle";
import { ButtonWithContext } from "@/shared/components/ButtonWithContext/ButtonWithContext";
import { DropdownWithContext } from "@/shared/components/DropdownWithContext/DropdownWithContext";
import { sortQtrItems } from "../helpers/sortQtrItems";
import { PEAD_FILTER_ITEMS, QTR_ITEMS } from "./const";

type Props = {
	widgetId: string;
};

export const PeadHeader: React.FC<Props & DropdownProps> = ({
	widgetId,
	state,
	onStateChange,
}) => {
	const sortedItems = useMemo(() => sortQtrItems(QTR_ITEMS, state), [state]);

	return (
		<div className="flex ml-2">
			<DropdownWithContext
				items={PEAD_FILTER_ITEMS}
				setter="setPeadFilter"
				contextValue="peadFilter"
				state={state}
				onStateChange={onStateChange}
				widgetId={widgetId}
				data-testid="pead-filter"
			/>

			<DropdownWithContext
				items={sortedItems}
				setter="setQtr"
				contextValue="qtr"
				state={state}
				onStateChange={onStateChange}
				widgetId={widgetId}
				data-testid="pead-qtr"
			/>

			<ButtonWithContext
				setter="setStdDev"
				contextValue="stdDev"
				className="pl-1"
				widgetId={widgetId}
				state={state}
				onStateChange={onStateChange}
			>
				Std
			</ButtonWithContext>
		</div>
	);
};
